import React from 'react';

/** One-line outcome of a tool action: filename/count on success, error on failure. */
export default function ToolResult({ result }) {
  if (!result) return null;
  if (!result.ok) return <p className="tool-error">Failed: {result.message}</p>;
  return <p className="text-muted">Done — {result.filename || `${result.count} graves updated`}</p>;
}
